import RecurrenceDetailModal from './RecurrenceDetailModal';

export default RecurrenceDetailModal;
